import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { BsXLg } from "react-icons/bs";

import ImpactList from "./ImpactList.js";
import ReliabilityBadge from "./ReliabilityBadge.js";
import SolutionTitle from "./SolutionTitle.js";

export default function ReportResultModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const solutionId = gData.state.currentSolutionId;
    if (solutionId === null) return (<></>);

    function closeReportResult () { gDispatch({ type: "closeResult" }); gDispatch({ type: "openReport" }); }


    return (
	<Modal
	    dialogClassName="modal-md"
	    show={gData.state.showModals.result}
	    onHide={closeReportResult}
	    centered
	>
	    <Modal.Header className="d-flex align-items-center justify-content-between bg-light">
		<Modal.Title className="d-flex gap-3 align-items-center">
		    <SolutionTitle solutionId={solutionId} size="md"/>
		    <span className="fs-5">Résultats de l'analyse</span>
		</Modal.Title>
		<Button variant="secondary" onClick={closeReportResult}><BsXLg/></Button>
	    </Modal.Header>
	    <Modal.Body>
		<div className="mb-2 d-flex align-items-center justify-content-between">
		    <div className="text-uppercase fs-5">Impacts estimés</div>
		    <ReliabilityBadge solutionId={solutionId}/>
		</div>
		<ImpactList solutionId={solutionId} type="analysis"/>
	    </Modal.Body>
	</Modal>
    );
}
